var me = Object.defineProperty;
var ge = (e, r, o) => r in e ? me(e, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[r] = o;
var Y = (e, r, o) => (ge(e, typeof r != "symbol" ? r + "" : r, o), o);
import { ref as h, Fragment as ve, unref as he, watch as A, onMounted as K, onBeforeUnmount as pe, computed as T, watchEffect as Q, mergeProps as N, cloneVNode as M, h as y, toRef as W, shallowRef as ye, nextTick as we, provide as k, inject as L, createCommentVNode as _, Transition as be } from "vue";
import { Portal as Fe, TransitionChild as Ce } from "@headlessui/vue";
import { arrow as xe, useFloating as Te } from "@floating-ui/vue";
import { offset as Ee, flip as Pe, shift as Ae, autoPlacement as Se, hide as Oe, autoUpdate as Re } from "@floating-ui/dom";
function V(e) {
  return e == null || e.value == null ? null : e.value instanceof Node ? e.value : "$el" in e.value && e.value.$el ? V(h(e.value.$el)) : "getBoundingClientRect" in e.value ? e.value : null;
}
function R(e) {
  const r = typeof window < "u" ? window.devicePixelRatio : 1;
  return Math.round(e * r) / r;
}
class Ne {
  constructor() {
    Y(this, "current", this.detect());
  }
  set(r) {
    this.current !== r && (this.current = r);
  }
  reset() {
    this.set(this.detect());
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}
const U = new Ne();
function H(e) {
  return e.reduce((r, o) => o.type === ve ? r.concat(H(o.children)) : r.concat(o), []);
}
function $(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
function q(e) {
  return e = he(e), e && (e == null ? void 0 : e.nodeType) !== Node.COMMENT_NODE;
}
function Z(e) {
  if (U.isServer)
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (Object.prototype.hasOwnProperty.call(e, "value")) {
    const r = V(e);
    if (r)
      return r.ownerDocument;
  }
  return document;
}
function Be(e, r, o, i, t) {
  A([
    () => t.offset,
    () => t.flip,
    () => t.shift,
    () => t.autoPlacement,
    () => t.arrow,
    () => t.hide,
    () => t.middleware
  ], () => {
    const a = [];
    (typeof t.offset == "number" || typeof t.offset == "object" || typeof t.offset == "function") && a.push(Ee(t.offset)), (t.flip === !0 || typeof t.flip == "number" || typeof t.flip == "object") && a.push(Pe({
      padding: typeof t.flip == "number" ? t.flip : void 0,
      ...typeof t.flip == "object" ? t.flip : {}
    })), (t.shift === !0 || typeof t.shift == "number" || typeof t.shift == "object") && a.push(Ae({
      padding: typeof t.shift == "number" ? t.shift : void 0,
      ...typeof t.shift == "object" ? t.shift : {}
    })), (t.autoPlacement === !0 || typeof t.autoPlacement == "object") && a.push(Se(
      typeof t.autoPlacement == "object" ? t.autoPlacement : void 0
    )), (t.arrow === !0 || typeof t.arrow == "number") && a.push(xe({
      element: i,
      padding: t.arrow === !0 ? 0 : t.arrow
    })), a.push(...typeof t.middleware == "function" ? t.middleware({
      referenceEl: r,
      floatingEl: o
    }) : t.middleware || []), (t.hide === !0 || typeof t.hide == "object") && a.push(Oe(
      typeof t.hide == "object" ? t.hide : void 0
    )), e.value = a;
  }, { immediate: !0 });
}
function je(e, r, o) {
  let i = () => {
  };
  K(() => {
    if (e && U.isClient && typeof ResizeObserver < "u" && r.value && r.value instanceof Element) {
      const t = new ResizeObserver(([a]) => {
        o.value = a.borderBoxSize.reduce((c, { inlineSize: s }) => c + s, 0);
      });
      t.observe(r.value), i = () => {
        t.disconnect(), o.value = null;
      };
    }
  }), pe(() => {
    i();
  });
}
const Je = [
  "origin-bottom",
  "origin-top",
  "origin-right",
  "origin-left",
  "origin-bottom-left",
  "origin-bottom-right",
  "origin-top-left",
  "origin-top-right"
], Ve = (e) => {
  switch (e) {
    case "top":
      return "origin-bottom";
    case "bottom":
      return "origin-top";
    case "left":
      return "origin-right";
    case "right":
      return "origin-left";
    case "top-start":
    case "right-end":
      return "origin-bottom-left";
    case "top-end":
    case "left-end":
      return "origin-bottom-right";
    case "right-start":
    case "bottom-start":
      return "origin-top-left";
    case "left-start":
    case "bottom-end":
      return "origin-top-right";
    default:
      return "origin-center";
  }
}, Ke = [
  "origin-bottom",
  "origin-top",
  "ltr:origin-right rtl:origin-left",
  "ltr:origin-left rtl:origin-right",
  "ltr:origin-bottom-left rtl:origin-bottom-right",
  "ltr:origin-bottom-right rtl:origin-bottom-left",
  "ltr:origin-top-left rtl:origin-top-right",
  "ltr:origin-top-right rtl:origin-top-left"
], Qe = (e) => {
  switch (e) {
    case "top":
      return "origin-bottom";
    case "bottom":
      return "origin-top";
    case "left":
      return "ltr:origin-right rtl:origin-left";
    case "right":
      return "ltr:origin-left rtl:origin-right";
    case "top-start":
    case "right-end":
      return "ltr:origin-bottom-left rtl:origin-bottom-right";
    case "top-end":
    case "left-end":
      return "ltr:origin-bottom-right rtl:origin-bottom-left";
    case "right-start":
    case "bottom-start":
      return "ltr:origin-top-left rtl:origin-top-right";
    case "left-start":
    case "bottom-end":
      return "ltr:origin-top-right rtl:origin-top-left";
    default:
      return "origin-center";
  }
};
function Ie(e, r) {
  const o = T(() => {
    if (typeof e.originClass == "function")
      return e.originClass(r.value);
    if (typeof e.originClass == "string")
      return e.originClass;
    if (e.tailwindcssOriginClass)
      return Ve(r.value);
  }), i = T(
    () => e.enter || o.value ? `${e.enter || ""} ${o.value || ""}` : void 0
  ), t = T(
    () => e.leave || o.value ? `${e.leave || ""} ${o.value || ""}` : void 0
  );
  return { originClassRef: o, enterActiveClassRef: i, leaveActiveClassRef: t };
}
function ee(e, r, ...o) {
  if (e in r) {
    const t = r[e];
    return typeof t == "function" ? t(...o) : t;
  }
  const i = new Error(
    `Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(
      r
    ).map((t) => `"${t}"`).join(", ")}.`
  );
  throw Error.captureStackTrace && Error.captureStackTrace(i, ee), i;
}
const G = [
  "[contentEditable=true]",
  "[tabindex]",
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "iframe",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])"
].map(
  // TODO: Remove this once JSDOM fixes the issue where an element that is
  // "hidden" can be the document.activeElement, because this is not possible
  // in real browsers.
  process.env.NODE_ENV === "test" ? (e) => `${e}:not([tabindex='-1']):not([style*='display: none'])` : (e) => `${e}:not([tabindex='-1'])`
).join(",");
var te = /* @__PURE__ */ ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(te || {});
function ze(e, r = 0) {
  var o;
  return e === ((o = Z(e)) == null ? void 0 : o.body) ? !1 : ee(r, {
    0() {
      return e.matches(G);
    },
    1() {
      let i = e;
      for (; i !== null; ) {
        if (i.matches(G))
          return !0;
        i = i.parentElement;
      }
      return !1;
    }
  });
}
function F(e, r, o) {
  U.isServer || Q((i) => {
    document.addEventListener(e, r, o), i(() => document.removeEventListener(e, r, o));
  });
}
function $e(e, r, o = T(() => !0)) {
  function i(a, c) {
    if (!o.value || a.defaultPrevented)
      return;
    const s = c(a);
    if (s === null || !s.getRootNode().contains(s))
      return;
    const u = function d(f) {
      return typeof f == "function" ? d(f()) : Array.isArray(f) || f instanceof Set ? f : [f];
    }(e);
    for (const d of u) {
      if (d === null)
        continue;
      const f = d instanceof HTMLElement ? d : V(d);
      if (f != null && f.contains(s) || a.composed && a.composedPath().includes(f))
        return;
    }
    return (
      // This check alllows us to know whether or not we clicked on a "focusable" element like a
      // button or an input. This is a backwards compatibility check so that you can open a <Menu
      // /> and click on another <Menu /> which should close Menu A and open Menu B. We might
      // revisit that so that you will require 2 clicks instead.
      !ze(s, te.Loose) && // This could be improved, but the `Combobox.Button` adds tabIndex={-1} to make it
      // unfocusable via the keyboard so that tabbing to the next item from the input doesn't
      // first go to the button.
      s.tabIndex !== -1 && a.preventDefault(), r(a, s)
    );
  }
  const t = h(null);
  F("mousedown", (a) => {
    var c, s;
    o.value && (t.value = ((s = (c = a.composedPath) == null ? void 0 : c.call(a)) == null ? void 0 : s[0]) || a.target);
  }, !0), F(
    "click",
    (a) => {
      t.value && (i(a, () => t.value), t.value = null);
    },
    // We will use the `capture` phase so that layers in between with `event.stopPropagation()`
    // don't "cancel" this outside click check. E.g.: A `Menu` inside a `DialogPanel` if the `Menu`
    // is open, and you click outside of it in the `DialogPanel` the `Menu` should close. However,
    // the `DialogPanel` has a `onClick(e) { e.stopPropagation() }` which would cancel this.
    !0
  ), F("blur", (a) => i(
    a,
    () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null
  ), !0);
}
const ne = Symbol("ReferenceContext"), re = Symbol("FloatingContext"), oe = Symbol("ArrowContext");
function ae(e) {
  const r = L(ne, null);
  if (r === null) {
    const o = new Error(`<${e} /> must be in the <Float /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, ae), o;
  }
  return r;
}
function ie(e) {
  const r = L(re, null);
  if (r === null) {
    const o = new Error(`<${e} /> must be in the <Float /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, ie), o;
  }
  return r;
}
function le(e) {
  const r = L(oe, null);
  if (r === null) {
    const o = new Error(`<${e} /> must be in the <Float /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, le), o;
  }
  return r;
}
const n = {
  as: {
    type: [String, Function],
    default: "template"
  },
  floatingAs: {
    type: [String, Function],
    default: "div"
  },
  show: {
    type: Boolean,
    default: null
  },
  placement: {
    type: String,
    default: "bottom-start"
  },
  strategy: {
    type: String,
    default: "absolute"
  },
  offset: [Number, Function, Object],
  shift: {
    type: [Boolean, Number, Object],
    default: !1
  },
  flip: {
    type: [Boolean, Number, Object],
    default: !1
  },
  arrow: {
    type: [Boolean, Number],
    default: !1
  },
  autoPlacement: {
    type: [Boolean, Object],
    default: !1
  },
  hide: {
    type: [Boolean, Object],
    default: !1
  },
  autoUpdate: {
    type: [Boolean, Object],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 9999
  },
  transitionName: String,
  transitionType: String,
  enter: String,
  enterFrom: String,
  enterTo: String,
  leave: String,
  leaveFrom: String,
  leaveTo: String,
  originClass: [String, Function],
  tailwindcssOriginClass: {
    type: Boolean,
    default: !1
  },
  portal: {
    type: Boolean,
    default: !1
  },
  transform: {
    type: Boolean,
    default: !1
  },
  adaptiveWidth: {
    type: Boolean,
    default: !1
  },
  composable: {
    type: Boolean,
    default: !1
  },
  dialog: {
    type: Boolean,
    default: !1
  },
  middleware: {
    type: [Array, Function],
    default: () => []
  }
};
function se(e, r, o, i) {
  const { referenceRef: t } = i, a = r, c = N(o, {
    ref: t
  }), s = M(
    e,
    a.as === "template" ? c : {}
  );
  return a.as === "template" ? s : typeof a.as == "string" ? y(a.as, c, [s]) : y(a.as, c, () => [s]);
}
function X(e, r, o, i) {
  const { floatingRef: t, props: a, mounted: c, show: s, x: u, y: d, placement: f, strategy: v, referenceElWidth: m, updateFloating: w } = i, l = N(
    { ...a, as: a.floatingAs },
    r
  ), { enterActiveClassRef: g, leaveActiveClassRef: C } = Ie(l, f), E = {
    enterActiveClass: g.value,
    enterFromClass: l.enterFrom,
    enterToClass: l.enterTo,
    leaveActiveClass: C.value,
    leaveFromClass: l.leaveFrom,
    leaveToClass: l.leaveTo
  }, x = {
    name: l.transitionName,
    type: l.transitionType,
    appear: !0,
    ...l.transitionName ? {} : E,
    onBeforeEnter() {
      s.value = !0;
    },
    onAfterLeave() {
      s.value = !1;
    }
  }, B = {
    enter: g.value,
    enterFrom: l.enterFrom,
    enterTo: l.enterTo,
    leave: C.value,
    leaveFrom: l.leaveFrom,
    leaveTo: l.leaveTo,
    onBeforeEnter: x.onBeforeEnter,
    onAfterLeave: x.onAfterLeave
  }, I = {
    style: {
      // If enable dialog mode, then set `transform` to false.
      ...!l.dialog && l.transform ? {
        position: v.value,
        zIndex: l.zIndex,
        top: "0px",
        left: "0px",
        right: "auto",
        bottom: "auto",
        transform: `translate(${R(u.value || 0)}px,${R(d.value || 0)}px)`
      } : {
        position: v.value,
        zIndex: l.zIndex,
        top: `${R(d.value || 0)}px`,
        left: `${R(u.value || 0)}px`
      },
      width: l.adaptiveWidth && typeof m.value == "number" ? `${m.value}px` : void 0
    }
  };
  function z(b) {
    return l.portal ? y(Fe, () => b) : b;
  }
  function P(b) {
    const S = N(
      I,
      o,
      l.dialog ? {} : { ref: t }
    );
    return l.as === "template" ? b : typeof l.as == "string" ? y(l.as, S, b) : y(l.as, S, () => b);
  }
  function j() {
    function b() {
      var p;
      const S = l.as === "template" ? N(
        I,
        o,
        l.dialog ? {} : { ref: t }
      ) : null, O = M(e, S);
      return ((p = O.props) == null ? void 0 : p.unmount) === !1 ? (w(), O) : typeof l.show != "boolean" || l.show ? O : _();
    }
    return U.isServer ? c.value && l.show ? b() : _() : l.transitionChild ? y(Ce, {
      key: `placement-${f.value}`,
      ...l.dialog ? { ref: t } : {},
      as: "template",
      ...B
    }, b) : y(be, {
      ...l.dialog ? { ref: t } : {},
      ...x
    }, b);
  }
  return z(
    P(
      j()
    )
  );
}
function ue(e, r, o, i, t) {
  const a = h(!1), c = W(i, "placement"), s = W(i, "strategy"), u = ye({}), d = h(null), f = h(void 0), v = h(void 0), m = T(() => V(r)), w = T(() => V(o)), l = T(
    () => q(m) && q(w)
  ), { x: g, y: C, placement: E, strategy: x, middlewareData: B, update: I } = Te(m, w, {
    placement: c,
    strategy: s,
    middleware: u
  }), z = h(null);
  K(() => {
    a.value = !0;
  }), A(e, (p, D) => {
    p && !D ? t("show") : !p && D && t("hide");
  }, { immediate: !0 });
  function P() {
    l.value && (I(), t("update"));
  }
  A([c, s, u], P, { flush: "sync" }), Be(
    u,
    m,
    w,
    d,
    i
  ), A(B, () => {
    const p = B.value.arrow;
    f.value = p == null ? void 0 : p.x, v.value = p == null ? void 0 : p.y;
  }), je(i.adaptiveWidth, m, z), A(e, async (p, D, ce) => {
    if (await we(), e.value && l.value && i.autoUpdate) {
      const de = Re(
        m.value,
        w.value,
        P,
        typeof i.autoUpdate == "object" ? i.autoUpdate : void 0
      );
      ce(de);
    }
  }, { flush: "post", immediate: !0 });
  const j = h(!0);
  A(m, () => {
    !(m.value instanceof Element) && l.value && j.value && (j.value = !1, window.requestAnimationFrame(() => {
      j.value = !0, P();
    }));
  }, { flush: "sync" });
  const b = {
    referenceRef: r,
    placement: E
  }, S = {
    floatingRef: o,
    props: i,
    mounted: a,
    show: e,
    x: g,
    y: C,
    placement: E,
    strategy: x,
    referenceElWidth: z,
    updateFloating: P
  }, O = {
    ref: d,
    placement: E,
    x: f,
    y: v
  };
  return k(oe, O), { referenceApi: b, floatingApi: S, arrowApi: O, x: g, y: C, placement: E, strategy: x, referenceEl: m, floatingEl: w, middlewareData: B, update: P };
}
const Ue = {
  name: "Float",
  inheritAttrs: !1,
  props: n,
  emits: ["show", "hide", "update"],
  setup(e, { emit: r, slots: o, attrs: i }) {
    const t = h(e.show ?? !1), a = h(null), c = h(null), {
      referenceApi: s,
      floatingApi: u,
      placement: d
    } = ue(t, a, c, e, r);
    function f(m) {
      return e.as === "template" ? m : typeof e.as == "string" ? y(e.as, i, m) : y(e.as, i, () => m);
    }
    const v = {
      placement: d.value
    };
    return e.composable || e.dialog ? (k(ne, s), k(re, u), () => {
      if (o.default)
        return f(o.default(v));
    }) : () => {
      if (!o.default)
        return;
      const [m, w] = H(o.default(v)).filter($);
      if (!$(m))
        return;
      const l = se(
        m,
        { as: "template" },
        {},
        s
      ), g = X(
        w,
        { as: e.floatingAs },
        {},
        u
      );
      return f([
        l,
        g
      ]);
    };
  }
}, De = {
  as: n.as
}, Ze = {
  name: "FloatReference",
  inheritAttrs: !1,
  props: De,
  setup(e, { slots: r, attrs: o }) {
    const i = ae("FloatReference"), { placement: t } = i;
    return () => {
      if (!r.default)
        return;
      const a = {
        placement: t.value
      };
      return se(
        r.default(a)[0],
        e,
        o,
        i
      );
    };
  }
}, J = {
  as: n.floatingAs,
  transitionName: n.transitionName,
  transitionType: n.transitionType,
  enter: n.enter,
  enterFrom: n.enterFrom,
  enterTo: n.enterTo,
  leave: n.leave,
  leaveFrom: n.leaveFrom,
  leaveTo: n.leaveTo,
  originClass: n.originClass,
  tailwindcssOriginClass: n.tailwindcssOriginClass,
  transitionChild: {
    type: Boolean,
    default: !1
  }
}, et = {
  name: "FloatContent",
  inheritAttrs: !1,
  props: J,
  setup(e, { slots: r, attrs: o }) {
    const i = ie("FloatContent"), { placement: t } = i;
    return () => {
      if (!r.default)
        return;
      const a = {
        placement: t.value
      }, c = Object.entries(e).reduce((s, [u, d]) => {
        const f = J;
        return (typeof f[u] == "object" && d === f[u].default || d === void 0) && delete s[u], s;
      }, { ...e });
      return X(
        r.default(a)[0],
        c,
        o,
        i
      );
    };
  }
}, ke = {
  as: {
    ...n.as,
    default: "div"
  },
  offset: {
    type: Number,
    default: 4
  }
}, tt = {
  name: "FloatArrow",
  props: ke,
  setup(e, { slots: r, attrs: o }) {
    const { ref: i, placement: t, x: a, y: c } = le("FloatArrow");
    return () => {
      var d;
      const s = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[t.value.split("-")[0]], u = {
        left: typeof a.value == "number" ? `${R(a.value)}px` : void 0,
        top: typeof c.value == "number" ? `${R(c.value)}px` : void 0,
        right: void 0,
        bottom: void 0,
        [s]: `${e.offset * -1}px`
      };
      if (e.as === "template") {
        const f = {
          placement: t.value
        }, v = (d = r.default) == null ? void 0 : d.call(r, f)[0];
        return !v || !$(v) ? void 0 : M(v, { ref: i, style: u });
      }
      return y(e.as, N(o, { ref: i, style: u }));
    };
  }
}, Me = {
  as: n.as,
  show: n.show,
  placement: n.placement,
  strategy: n.strategy,
  offset: n.offset,
  shift: n.shift,
  flip: n.flip,
  arrow: n.arrow,
  autoPlacement: n.autoPlacement,
  hide: n.hide,
  autoUpdate: n.autoUpdate,
  zIndex: n.zIndex,
  transitionName: n.transitionName,
  transitionType: n.transitionType,
  enter: n.enter,
  enterFrom: n.enterFrom,
  enterTo: n.enterTo,
  leave: n.leave,
  leaveFrom: n.leaveFrom,
  leaveTo: n.leaveTo,
  originClass: n.originClass,
  tailwindcssOriginClass: n.tailwindcssOriginClass,
  portal: n.portal,
  transform: n.transform,
  middleware: n.middleware
}, fe = {
  name: "FloatVirtual",
  inheritAttrs: !1,
  props: Me,
  emits: ["initial", "show", "hide", "update"],
  setup(e, { emit: r, slots: o, attrs: i }) {
    const t = h(e.show ?? !1), a = h({
      getBoundingClientRect() {
        return {
          x: 0,
          y: 0,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: 0,
          height: 0
        };
      }
    }), c = h(null), {
      floatingApi: s,
      placement: u
    } = ue(t, a, c, e, r);
    A(() => e.show, () => {
      t.value = e.show ?? !1;
    });
    function d() {
      t.value = !1;
    }
    return r("initial", {
      show: t,
      placement: u,
      reference: a,
      floating: c
    }), () => {
      if (!o.default)
        return;
      const f = {
        placement: u.value,
        close: d
      }, [v] = H(o.default(f)).filter($);
      return X(
        v,
        {
          as: e.as,
          show: t.value
        },
        i,
        s
      );
    };
  }
}, Le = {
  as: n.as,
  placement: n.placement,
  strategy: n.strategy,
  offset: n.offset,
  shift: n.shift,
  flip: {
    ...n.flip,
    default: !0
  },
  arrow: n.arrow,
  autoPlacement: n.autoPlacement,
  hide: n.hide,
  autoUpdate: n.autoUpdate,
  zIndex: n.zIndex,
  transitionName: n.transitionName,
  transitionType: n.transitionType,
  enter: n.enter,
  enterFrom: n.enterFrom,
  enterTo: n.enterTo,
  leave: n.leave,
  leaveFrom: n.leaveFrom,
  leaveTo: n.leaveTo,
  originClass: n.originClass,
  tailwindcssOriginClass: n.tailwindcssOriginClass,
  transform: n.transform,
  middleware: n.middleware
}, nt = {
  name: "FloatContextMenu",
  inheritAttrs: !1,
  props: Le,
  emits: ["show", "hide", "update"],
  setup(e, { emit: r, slots: o, attrs: i }) {
    function t({ show: a, reference: c, floating: s }) {
      F("contextmenu", (u) => {
        u.preventDefault(), c.value = {
          getBoundingClientRect() {
            return {
              width: 0,
              height: 0,
              x: u.clientX,
              y: u.clientY,
              top: u.clientY,
              left: u.clientX,
              right: u.clientX,
              bottom: u.clientY
            };
          }
        }, a.value = !0;
      }), $e(s, () => {
        a.value = !1;
      }, T(() => a.value));
    }
    return () => {
      if (o.default)
        return y(fe, {
          ...e,
          ...i,
          portal: !0,
          onInitial: t,
          onShow: () => r("show"),
          onHide: () => r("hide"),
          onUpdate: () => r("update")
        }, o.default);
    };
  }
}, He = {
  as: n.as,
  placement: n.placement,
  strategy: n.strategy,
  offset: n.offset,
  shift: n.shift,
  flip: n.flip,
  arrow: n.arrow,
  autoPlacement: n.autoPlacement,
  hide: n.hide,
  autoUpdate: n.autoUpdate,
  zIndex: n.zIndex,
  transitionName: n.transitionName,
  transitionType: n.transitionType,
  enter: n.enter,
  enterFrom: n.enterFrom,
  enterTo: n.enterTo,
  leave: n.leave,
  leaveFrom: n.leaveFrom,
  leaveTo: n.leaveTo,
  originClass: n.originClass,
  tailwindcssOriginClass: n.tailwindcssOriginClass,
  transform: n.transform,
  middleware: n.middleware,
  globalHideCursor: {
    type: Boolean,
    default: !0
  }
}, rt = {
  name: "FloatCursor",
  inheritAttrs: !1,
  props: He,
  emits: ["show", "hide", "update"],
  setup({ globalHideCursor: e, ...r }, { emit: o, slots: i, attrs: t }) {
    function a({ show: c, reference: s, floating: u }) {
      function d() {
        c.value = !0;
      }
      function f() {
        c.value = !1;
      }
      function v(g) {
        s.value = {
          getBoundingClientRect() {
            return {
              width: 0,
              height: 0,
              x: g.clientX,
              y: g.clientY,
              top: g.clientY,
              left: g.clientX,
              right: g.clientX,
              bottom: g.clientY
            };
          }
        };
      }
      function m(g) {
        d(), v(g);
      }
      function w(g) {
        d(), v(g.touches[0]);
      }
      const l = Z(u);
      l && (Q((g) => {
        if (e && !l.getElementById("headlesui-float-cursor-style")) {
          const C = l.createElement("style");
          (l.head || l.getElementsByTagName("head")[0]).appendChild(C), C.id = "headlesui-float-cursor-style", C.appendChild(l.createTextNode([
            "*, *::before, *::after {",
            "  cursor: none !important;",
            "}",
            ".headlesui-float-cursor-root {",
            "  pointer-events: none !important;",
            "}"
          ].join(`
`))), g(() => {
            var x;
            return (x = l.getElementById("headlesui-float-cursor-style")) == null ? void 0 : x.remove();
          });
        }
      }, { flush: "post" }), "ontouchstart" in window || navigator.maxTouchPoints > 0 ? (F("touchstart", w), F("touchend", f), F("touchmove", w)) : (F("mouseenter", m), F("mouseleave", f), F("mousemove", m)));
    }
    return () => {
      if (i.default)
        return y(fe, {
          ...r,
          ...t,
          portal: !0,
          class: "headlesui-float-cursor-root",
          onInitial: a,
          onShow: () => o("show"),
          onHide: () => o("hide"),
          onUpdate: () => o("update")
        }, i.default);
    };
  }
};
function ot(e) {
  return (r, { slots: o }) => y(Ue, N(
    e,
    r
  ), o);
}
const Xe = [
  "Float",
  "FloatArrow"
];
function at(e = {}) {
  const { prefix: r = "" } = e;
  return {
    type: "component",
    resolve: (o) => {
      if (o.startsWith(r)) {
        const i = o.substring(r.length);
        if (Xe.includes(i))
          return {
            name: i,
            from: "@headlessui-float/vue"
          };
      }
    }
  };
}
export {
  Ue as Float,
  tt as FloatArrow,
  ke as FloatArrowPropsValidators,
  et as FloatContent,
  J as FloatContentPropsValidators,
  nt as FloatContextMenu,
  Le as FloatContextMenuPropsValidators,
  rt as FloatCursor,
  He as FloatCursorPropsValidators,
  n as FloatPropsValidators,
  Ze as FloatReference,
  De as FloatReferencePropsValidators,
  fe as FloatVirtual,
  Me as FloatVirtualPropsValidators,
  at as HeadlessUiFloatResolver,
  ot as createHighOrderFloatComponent,
  X as renderFloatingElement,
  se as renderReferenceElement,
  Ve as tailwindcssOriginClassResolver,
  Je as tailwindcssOriginSafelist,
  Qe as tailwindcssRtlOriginClassResolver,
  Ke as tailwindcssRtlOriginSafelist,
  ue as useFloat,
  $e as useOutsideClick
};
